<template>
  <hr class="section-rule rule" />
</template>

<script>
export default {
  name: 'SectionRule'
}
</script>

<style lang="sass" scoped>
.section-rule
  margin: $margin-lg auto
</style>
